import { ActionTree } from "vuex"

import { SohoModel } from "~/constants/SohoModel"
import { RequestParameters } from "~/utils/SohoApi/SohoApi"
import { setIncludedResources } from "~/utils/store"

import { RootState } from "../store.types";
import {
  AvailabilitiesFilter,
  AvailabilitiesState,
  Availability,
  AvailabilityResource,
  AvailabilityFilter
} from "~/store/availabilities/availabilities.types"

const actions: ActionTree<AvailabilitiesState, RootState> = {
  async fetchAvailabilities ({ commit }, params: RequestParameters<Availability, AvailabilitiesFilter> = {}) {
    const { data, included } = await this.$sohoApi.get<AvailabilityResource>(SohoModel.Availability, params)

    // Optionally set the included resources
    if (included) {
      setIncludedResources(included, commit)
    }

    if (data) {
      commit("SET_AVAILABILITIES", { params, data })
    }
  },

  async fetchAvailability ({ commit }, params: RequestParameters<Availability, AvailabilityFilter> = {}) {
    const { data, included } = await this.$sohoApi.get<AvailabilityResource>(SohoModel.Availability, params)

    // Optionally set the included resources
    if (included) {
      setIncludedResources(included, commit)
    }

    if (data) {
      commit("SET_AVAILABILITY", { params, data })
    }
  }
}

export default actions
